import { LabeledSelectField } from '@components';

export enum AuthTypes {
  None = 'none',
  OAuth = 'oauth',
}

interface AuthenticationTypeFieldProps {
  value: AuthTypes;
  onChange: (value: AuthTypes) => void;
}

function AuthenticationTypeField({ value, onChange }: AuthenticationTypeFieldProps) {
  const options = [
    { key: AuthTypes.None, value: 'None' },
    { key: AuthTypes.OAuth, value: 'OAuth' },
  ];

  return (
    <LabeledSelectField
      label="Authentication Type"
      options={options}
      value={value}
      onChange={(e) => onChange(e.target.value as AuthTypes)}
    />
  );
}

export default AuthenticationTypeField;
